import {
  type BenefitPlanGroup,
  BenefitPlanTypeEnum,
} from "@platform/btx-plan-designer";

const PRODUCT_TYPE_LABELS: Record<string, string> = {
  [BenefitPlanTypeEnum.PPO]: "PPO",
  [BenefitPlanTypeEnum.HMO]: "HMO",
  [BenefitPlanTypeEnum.EPO]: "EPO",
  [BenefitPlanTypeEnum.POS]: "POS",
  [BenefitPlanTypeEnum.INDEMNITY]: "Indemnity",
};

export const getBenefitPlanGroupLabel = (group: BenefitPlanGroup): string =>
  group.nickname ||
  group.benefitPlans[0]?.identifier ||
  PRODUCT_TYPE_LABELS[group.productType] ||
  `Plan Group ${group.position}`;
